export default "__VITE_ASSET__DgtTS$YU__"